module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bank/addbank/addbank.component.css
// module id = ./src/app/bank/addbank/addbank.component.css
// module chunks = main